<template>
    <div id="nav" class="mobile-nav">
        <div class="mobile-button" :style="{
      opacity,
      transform
    }">
            <v-icon color="white" dark x-large v-on:click="toggleMenu">{{ whichIcon }}</v-icon>
        </div>
        <div class="mobile-menu-container" v-if="menuOpen">
            <!-- <Logo class="mobile-logo" position="static" @click.native="closeMenu"/> -->
            <Nav class="mobile-page-items" @click.native="closeMenu"/>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import pageLoadAnimationBus from '../pageLoadAnimationBus'
export default {
  components: {
    Nav
    // Logo
  },
  data () {
    return {
      opacity: 1,
      translateY: 0
    }
  },
  mounted () {
    pageLoadAnimationBus.registerComponent('nav', this)
  },
  computed: {
    menuOpen () { return this.$store.state.menuOpen },
    whichIcon () {
      return (this.menuOpen) ? 'mdi-close' : 'mdi-menu'
    },
    transform () { return 'translateY(' + (this.translateY).toString() + 'px)' }
  },
  methods: {
    openMenu () { this.$store.dispatch('setMenuOpen', true) },
    closeMenu () { this.$store.dispatch('setMenuOpen', false) },
    toggleMenu () {
      if (this.menuOpen) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    }
  }
}
</script>

<style lang="scss">
.mobile-nav{
    z-index: 100000;

    .mobile-menu-container{
        position: absolute;
        top: 0;
        //right: 0;
        width: 100vw;
        height: 100vh; /* Fallback for browsers that do not support Custom Properties */
        height: calc(var(--vh, 1vh) * 100);
        z-index: 20000;
        background-color: rgba($color:#E4AF79, $alpha: 1);

        a{
            display: block;
            font-size: 40px;
            padding: 20px;
            border-bottom: 2px solid white;
            letter-spacing: -0.035em;
        }
        .close-button{
            float: right;
            margin: 30px 0 0 20px;
            font-weight: bold;
            font-size: 30px;
            color: white;
        }
        .mobile-page-items{
            text-align: center;
            margin-top: 150px;
        }
    }
    .mobile-button{
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 100000;
    }
}

</style>
